<template>
  <!-- Główny kontener dla widoku VMS (tablica znaków zmiennej treści) -->
  <div class="content-container">
    <!-- Panel filtrów danych VMS (lewa kolumna) -->
    <filter-vms-data />
    <div class="content-wrap">
      <!-- Pasek górnego menu (nawigacja, logo, user itp.) -->
      <TopMenu />
      <!-- Lista grup VMS (przekazuje statusy i opisy grup jako propsy) -->
      <vms-list 
        :group-statuses="vmsStore.groupStatuses"
        :group-descriptions="vmsStore.groupDescriptions"
      />
    </div>
  </div>
</template>

<script>
// Import wymaganych komponentów i Pinia Store
import TopMenu from "../components/TopMenu.vue";
import VmsList from "@/components/Vms";
import { useVmsStore } from "@/stores/vms";
import FilterVmsData from "@/components/FilterVmsData.vue";

export default {
  name: "VmsView",
  components: {
    VmsList,           // Komponent listy znaków VMS
    TopMenu,           // Pasek nawigacyjny u góry
    FilterVmsData,     // Panel boczny z filtrami
  },
  setup() {
    // Ładowanie Pinia store z danymi VMS (statusy, opisy)
    const vmsStore = useVmsStore();
    // Store używany do przekazania statusów i opisów do komponentu VmsList
    return { vmsStore };
  },
  data() {
    return {
      // (Nieużywane, zostawione z szablonu, można usunąć)
      groupStatuses: [],
    };
  },
};
</script>

<style scoped>
/* Główne tło widoku VMS */
.content-container {
  background-color: #f5f4f2;
}

/* Stylowanie przycisków i akcji (część wspólnego stylu aplikacji) */
button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}
/* Przyciski typu "dalej" */
.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}
.btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}
.btn-next:hover {
  color: black;
}
.btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}
/* Sekcja akcji (dół/ góra) */
.actions, .actions-down {
  background-color: #ffffff;
  width: 100%;
}
.actions button, .actions-down button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}
.actions .btn-prev, .actions-down .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
}
.actions .btn-prev:before, .actions-down .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}
.actions .btn-prev:hover, .actions-down .btn-prev:hover {
  color: black;
}
.actions .btn-prev:hover:before, .actions-down .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}
.actions-down {
  margin-top: 2rem !important;
}
</style>
